export const Academy = {
  Type: {
    academy: 1,
    schoolHouse: 2,
    privateLesson: 3,
    etc: 99,
  },
  Subject: {
    korean: 1,
    english: 2,
    math: 4,
    science: 8,
    socialStudies: 16,
    music: 32,
    art: 64,
    pe: 128,
    coding: 256,
    etc: 65536,
  },
};

export const Cls = {
  Status: {
    inOperation: 1,
    closed: 2,
    deleted: 3,
  },
};

export const Student = {
  Status: {
    enrolled: 1,
    notEnrolled: 2,
    deleted: 3,
  },
};

export const Teacher = {
  Position: {
    director: 10,
    assistantDirector: 20,
    regularTeacher: 40,
  },
  Status: {
    employed: 1,
    resigned: 2,
    deleted: 3,
  },
  tagColorFallback: '969696',
  tagColorList: [
    // 15 base colors: 12-wheel + e91e63 + brown + dark gray
    // each group: base -> white mix 2:1 -> white mix 1:1

    // R
    'f21711',
    'f66460',
    'f98b88',

    // RO
    'ff5733',
    'ff8f77',
    'ffab99',

    // O
    'ff8d1a',
    'ffb366',
    'ffc68d',

    // YO
    'ffb300',
    'ffcc55',
    'ffd980',

    // Y
    'ffeb3b',
    'fff27c',
    'fff59d',

    // YG
    'add45c',
    'c8e292',
    'd6eaae',

    // G
    '4caf50',
    '88ca8a',
    'a6d7a8',

    // BG
    '0f998a',
    '5fbbb1',
    '87ccc5',

    // B
    '2196f3',
    '6bb9f7',
    '90cbf9',

    // BV
    '3f51b5',
    '7f8bce',
    '9fa8da',

    // V
    '673ab7',
    '9a7ccf',
    'b39ddb',

    // RV
    '9c27b0',
    'bd6fca',
    'ce93d8',

    // e91e63
    'e91e63',
    'f06997',
    'f48fb1',

    // brown
    '775549',
    'a48e86',
    'bbaaa4',

    // dark gray
    '5d5d5d',
    '939393',
    'cccccc',
  ],
};

export const DashboardStats = {
  maxRecentDays: 31,
  maxRecentMonths: 13,
};
